import {AttachmentDetails} from "@/interfaces/AttachmentInterfaces";

export interface Task {
  id: number;
  title: string;
  description: string;
  note: string;
  parentTaskId?: number;
  parentTitle?: string;
  dueDatetime?: Date | null;
  remindDatetime?: Date | null;
  taskColumnId?: Column;
  taskColorId?: Color;
  isEmergency: boolean;
  isComplete: boolean;
  completeDatetime?: Date | null;
  isRead: boolean;
  isPrivate: boolean;
  createdDatetime: Date;
  createdByAppUserId: number;
  updatedDatetime?: Date | null;
  updatedByAppUserId: number;
  assignedToAppUserId: number | null;
  assignedToAppUserIdList: number[] | null;
  assignedToSecurityRoleId: number | null;
  assignedDatetime: Date;
  assignedByAppUserId: number;
  displayOrder: number;
  childTasks: ChildTask[];
  checklist: ChecklistItem[];
  attachments: AttachmentDetails[];
  isEditing: boolean;
  showDetails: boolean;
  shiftId: number | null;
}

export interface ChildTask {
  id: number;
  title: string;
  isComplete: boolean;
  assignedToAppUserId: number;
  assignedToSecurityRoleId: number;
}

export interface ChecklistItem {
  id: number;
  title: string;
  note: string;
  isComplete: boolean;
  updatedDatetime: Date;
  isEditing?: boolean;
}

export enum Column {
  TODAY = 1,
  THIS_WEEK = 2,
  LATER = 3,
  WAITING = 4,
  INCOMING = 10,
  COMPLETE = 11
}

export enum Color {
  PURPLE = 1,
  RED = 2,
  BLUE = 3,
  GREEN = 4,
  YELLOW = 5
}

export enum UpdateFields {
  COLOR = 'color',
  DESCRIPTION = 'description',
  DUE_BY = 'dueBy',
  EMERGENCY = 'emergency',
  PRIVATE = 'private',
  IS_READ = 'isRead',
  NOTES = 'notes',
  REMIND_ON = 'remindOn',
  TITLE = 'title',
  TASK_COLUMN_ID = 'taskColumnId',
  SECURITY_ASSIGNMENT = 'securityAssignment',
  USER_ASSIGNMENT = 'userAssignment',
  COMPLETE = 'complete',
}

export interface ChecklistTemplateSummary {
  id: number;
  name: string;
  createdByAppUserId: number;
}

export interface TaskReorderParams {
  movedTaskInfo: MovedTaskInfo | null;
  oldColumn: ColumnReorder | null;
  newColumn: ColumnReorder | null;
}

export interface ColumnReorder {
  assignedToAppUserId: number | null;
  assignedToSecurityRoleId: number | null;
  columnId: number;
  orderings: IdAndOrder[];
}

export interface MovedTaskInfo {
  taskId: number;
  isComplete: boolean;
}

export interface IdAndOrder {
  taskId: number;
  columnOrder: number;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/interfaces/TaskInterfaces.ts